@import (reference) '../../constants/spacing.module.less';

.search-results {
  position: relative;

  .result-dropdown-menu {
    position: absolute;
    bottom: @space-40;
    left: @space-8;
    z-index: 2;
    background-color: var(--white);
    border-radius: 4px;
    border: 1px solid var(--grey-300);
    max-height: 200px;
    overflow: auto;
    box-shadow: 1px 1px 3px var(--black-fade-20);
  }

  .result-item {
    font-size: 12px;
    border-bottom: 1px solid var(--grey-400);

    &:last-child {
      border-bottom: 0;
    }

    .menu-item {
      &:focus {
        background: var(--grey-200);
      }
    }
  }
}
